export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  INFO: 'ALERT_INFO',
  CLEAR: 'ALERT_CLEAR',
}
